// Utility function to fetch data with AJAX
async function fetchCartData(url, method = "GET", bodyData = null) {
  const options = {
    method: method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  if (bodyData) options.body = JSON.stringify(bodyData);

  const response = await fetch(url, options);
  return await response.json();
}

// Open Cart Drawer Function
function openCartDrawer() {
  const cartDrawer = document.querySelector(".f-cart-drawer");
  cartDrawer.classList.add("f-cart-drawer--active");
  variantSelection();

  var elements = $('.f-cart-drawer-item .frog_main'); 
  if(elements.length > 0){
    $('.f-cart-drawer-item .frog_main:first').removeClass('hidden');
  }
  
}

// Close Cart Drawer Function
function closeCartDrawer() {
  document.querySelector(".f-cart-drawer").classList.remove("f-cart-drawer--active");
}

// Update Cart Item Count Function
async function updateCartItemCount(count = 0) {
  const cart = await fetchCartData('/cart.js');
  const itemCount = count !== 0 ? count : cart.item_count;
  document.querySelectorAll('.cart-count-bubble').forEach(el => {
    el.textContent = itemCount;
    el.classList.toggle('empty_cart', itemCount <= 0);
  });
}

// Update Cart Drawer Function
async function updateCartDrawer() {
  try {
    const res = await fetch('/?section_id=unit-drawer');
    const html = document.createElement("div");
    html.innerHTML = await res.text();

    const newDrawerContent = html.querySelector(".f-cart-drawer");
    if (newDrawerContent) {
      const cartDrawer = document.querySelector('.f-cart-drawer');
      if (cartDrawer) {
        cartDrawer.innerHTML = newDrawerContent.innerHTML;
      }
    } else {
      console.error("Error: Unable to find the '.f-cart-drawer' element in the fetched content.");
    }

    // Re-attach event listeners after updating the cart drawer content
    addCartDrawerListeners();
    removeCartDrawerListeners();
    addCartUpsellListeners();
    addCartUpsellListeners2();
    variantSelection();

    // Fetch the current cart data to check item count
    const cartData = await fetch('/cart.js').then(response => response.json());

    // Now check item count and toggle button state
    const itemsCount = cartData.item_count;
    const shippingProtectionCheckbox = document.querySelector('#shippingProtection');

    if (shippingProtectionCheckbox && !manualCheckboxToggle) {
      // Only proceed with programmatic toggle if it wasn't manually clicked
      if (itemsCount > 0 && !shippingProtectionCheckbox.checked) {
        // If cart items > 1 and checkbox is not checked, check it
        if (!sessionStorage.getItem('shippingProtectionClicked')) {
          shippingProtectionCheckbox.click();
          sessionStorage.setItem('shippingProtectionClicked', 'true');
        }
        // Trigger click event to check the checkbox
      } else if (itemsCount <= 1 && shippingProtectionCheckbox.checked) {
        // If cart items <= 1 and checkbox is checked, uncheck it
        shippingProtectionCheckbox.click();  // Trigger click event to uncheck the checkbox
      }
    }
    
    var elements = $('.f-cart-drawer-item .frog_main'); 
    if(elements.length > 0){
      $('.f-cart-drawer-item .frog_main:first').removeClass('hidden');
    }

    if($('#StickySubtotal').length > 0){
      if($('.f-cart-drawer-button').length > 0){
      var carttot = $('.f-cart-drawer-button').text().split('Checkout •')[1];
      $('#StickySubtotal').text(carttot);
      $('#StickySubmit').removeAttr('disabled');
      }else{
        var defprc = $('#StickySubtotal').attr('data-attr');
        $('#StickySubtotal').text(defprc);
        $('#StickySubmit').attr('disabled',true);
      }

      if (itemsCount == 1 ){
        $('#StickyItems').text(itemsCount+' item');
      }else {
        $('#StickyItems').text(itemsCount+' items');
      }

      if (itemsCount > 0 ){
        $('#StickyCart').addClass('active');
        $('.mob-thumb-menu-cstm-cls').addClass('hidden');
      }else{
        $('#StickyCart').removeClass('active');
        $('.mob-thumb-menu-cstm-cls').removeClass('hidden');
      }
      
    }
    
  } catch (error) {
    console.error("Failed to update cart drawer:", error);
  }
}

// Add Event Listeners for Cart Drawer
function addCartDrawerListeners() {
  
  document.querySelectorAll('.f-cart-drawer-quantity-selector:not(.mainFound) button').forEach(button => {
    button.addEventListener("click", async () => {
      button.querySelector('.icon').classList.add('hidden');
      button.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const rootItem = button.closest('[data-line-item-key]');
      const key = rootItem.getAttribute("data-line-item-key");
      const currentQuantity = Number(button.parentElement.querySelector('input').value);
      const isUp = button.classList.contains('f-cart-drawer-quantity-selector-plus');
      const newQuantity = isUp ? currentQuantity + 1 : Math.max(currentQuantity - 1, 0);

      const cart = await fetchCartData('/cart/update.js', 'POST', { updates: { [key]: newQuantity } });
      await updateCartItemCount(cart.item_count);
      await updateCartDrawer();

      button.querySelector('.icon').classList.remove('hidden');
      button.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
  });

  document.querySelectorAll('.f-cart-drawer-quantity-selector.mainFound button').forEach(button => {
    button.addEventListener("click", async () => {
      button.querySelector('.icon').classList.add('hidden');
      button.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      let lineItemkeyArray = [];
      const rootItem = button.closest('[data-line-item-key]');
      const parentItemID = rootItem.getAttribute("data-main-id");
      const parentItemProperty = rootItem.getAttribute("data-property");
      const key = rootItem.getAttribute("data-line-item-key");
      const currentQuantity = Number(button.parentElement.querySelector('input').value);
      const isUp = button.classList.contains('f-cart-drawer-quantity-selector-plus');
      const newQuantity = isUp ? currentQuantity + 1 : Math.max(currentQuantity - 1, 0);

      lineItemkeyArray.push(key);

      let itemsBundle = document.querySelectorAll(`.bundle_item[data-bundle-id="${parentItemID}"]`);

        itemsBundle.forEach(function(item_input) {
          let itemKey = item_input.getAttribute("data-line-item-key");
          let itemPropertyData = item_input.getAttribute("data-property");
          if (itemPropertyData == parentItemProperty) {
            if (newQuantity != item_input.value) {
              item_input.value = newQuantity;
              if (!lineItemkeyArray.includes(itemKey)) {
                  lineItemkeyArray.push(itemKey);
              }         
            }         
      
          }        
      });
       // Function to check if an object is empty
         function isObjectEmpty(obj) {
            return Object.keys(obj).length === 0;
        }
        
        // Function to update cart
        async function updateCartCustom(lineItemsToUpdate) {
            if (isObjectEmpty(lineItemsToUpdate)) {
                console.log('No updates to make.');
                return; // Exit the function if there are no updates
            }
        
            try {
                const response = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        updates: lineItemsToUpdate
                    })
                });
        
                const data = await response.json();
                console.log('Cart updated:', data);
        
                await updateCartItemCount(); // Await other async functions
                await updateCartDrawer();
            } catch (error) {
                console.error('Error:', error);
            }
        }

        
        // Prepare line items for update
        let updates = {};
        lineItemkeyArray.forEach(itemKey => {
            updates[itemKey] = newQuantity; 
        });
        
        // Update the cart
       await updateCartCustom(updates);

      // const cart = await fetchCartData('/cart/update.js', 'POST', { updates: { [key]: newQuantity } });

      button.querySelector('.icon').classList.remove('hidden');
      button.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
  });
  

  document.querySelector(".f-cart-drawer-box").addEventListener("click", (e) => e.stopPropagation());

  document.querySelectorAll(".f-cart-drawer-header-right-close, .f-cart-drawer").forEach(el => {
    el.addEventListener("click", closeCartDrawer);
  });
  
}

// Remove Cart Item Function
function removeCartDrawerListeners() {
  document.querySelectorAll('.f-cart-drawer-item-main-flex-right:not(.mainFound) button').forEach(button => {
    button.addEventListener("click", async (e) => {
      e.preventDefault();
      const rootItem = button.closest('[data-line-item-key]');
      const key = rootItem.getAttribute("data-line-item-key");

      const cart = await fetchCartData('/cart/update.js', 'POST', { updates: { [key]: 0 } });
      await updateCartItemCount(cart.item_count);
      await updateCartDrawer();
    });
  });

  document.querySelectorAll('.f-cart-drawer-item-main-flex-right.mainFound button').forEach(button => {
    button.addEventListener("click", async (e) => {
        e.preventDefault();
        
        const rootItem = button.closest('[data-line-item-key]');
        if (!rootItem) return;

        const key = rootItem.getAttribute("data-line-item-key");
        const parentItemID = rootItem.getAttribute("data-main-id");
        const parentItemProperty = rootItem.getAttribute("data-property");

        let lineItemkeyArray = [key];
        let newQuantity = 0;

        // Find all bundle items with the same parent ID
        let itemsBundle = document.querySelectorAll(`.bundle_item[data-bundle-id="${parentItemID}"]`);
        
        itemsBundle.forEach(item => {
            let itemKey = item.getAttribute("data-line-item-key");
            let itemPropertyData = item.getAttribute("data-property");

            if (itemPropertyData === parentItemProperty && !lineItemkeyArray.includes(itemKey)) {
                lineItemkeyArray.push(itemKey);
            }
        });

        // Function to check if an object is empty
        function isObjectEmpty(obj) {
            return Object.keys(obj).length === 0;
        }

        // Function to update cart
        async function updateCartCustom(lineItemsToUpdate) {
            if (isObjectEmpty(lineItemsToUpdate)) {
                console.log('No updates to make.');
                return;
            }

            try {
                const response = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates: lineItemsToUpdate })
                });

                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

                const data = await response.json();
                console.log('Cart updated:', data);

                await updateCartItemCount();
                await updateCartDrawer();
            } catch (error) {
                console.error('Cart update failed:', error);
            }
        }

        // Prepare updates
        let updates = {};
        lineItemkeyArray.forEach(itemKey => {
            updates[itemKey] = newQuantity;
        });

        // Ensure items are fully removed
        if (Object.keys(updates).length > 0) {
            await updateCartCustom(updates);
        }
    });
});
}

// Add Upsell Listeners
function addCartUpsellListeners() {
  document.querySelectorAll('.add.f-upsale-add').forEach(button => {
    button.addEventListener("click", async (e) => {
      e.preventDefault();
      button.querySelector('span').classList.add('hidden');
      button.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const key = button.getAttribute("data-variant-id");
      const cart = await fetchCartData('/cart/update.js', 'POST', { updates: { [key]: 1 } });
      await updateCartItemCount(cart.item_count);
      await updateCartDrawer();

      button.querySelector('span').classList.remove('hidden');
      button.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
  });
}

// Global variable to track manual clicks
let manualCheckboxToggle = false;

// Function to handle manual checkbox clicks (from addCartUpsellListeners2)
function addCartUpsellListeners2() {
  document.querySelectorAll('#shippingProtection').forEach(button => {
    button.addEventListener("change", async (e) => {
      const key = 46565880922344; // Variant ID

      // Set manual checkbox toggle flag to true when the user manually changes the checkbox
      manualCheckboxToggle = true;

      // Check if the checkbox is checked
      if (e.target.checked) {
        // If checked, add the variant (quantity = 1)
        const cart = await fetchCartData('/cart/update.js', 'POST', { updates: { [key]: 1 } });
        await updateCartItemCount(cart.item_count);
        await updateCartDrawer();
      } else {
        // If unchecked, remove the variant (quantity = 0)
        const cart = await fetchCartData('/cart/update.js', 'POST', { updates: { [key]: 0 } });
        await updateCartItemCount(cart.item_count);
        await updateCartDrawer();
      }

      // Reset the manual toggle flag after processing the click
      manualCheckboxToggle = false;
    });
  });
}

// Variant Selection Function
function variantSelection() {
  document.querySelectorAll('.f-upsale-main select').forEach(select => {
    select.addEventListener('change', () => {
      const parentDiv = select.closest('.f-upsale-main');
      const btn = parentDiv.querySelector('.f-upsale-add');
      btn.setAttribute('data-variant-id', select.value);
    });
  });
}

// Form Submission Handler
document.body.addEventListener("click", async (e) => {
        // Check if the clicked element is a .add-to-cart button
        const btn = e.target.closest('.add-to-cart');
  btn.querySelector('svg').classList.remove('hidden2');
  btn.classList.add('txt_indent');
        if (!btn) return; // Exit if the click is not on an .add-to-cart button

        e.preventDefault(); // Prevent default form submission behavior

        const form = btn.closest('form[action="/cart/add"]');
        if (!form) {
            console.error("Form not found for the clicked add-to-cart button.");
            return;
        }

        try {
            // Add the product to the cart
            await fetch('/cart/add.js', { 
                method: "POST", 
                body: new FormData(form) 
            });

            // Update the cart drawer and item count
            await updateCartDrawer();
            await updateCartItemCount();
btn.querySelector('svg').classList.add('hidden2');
  btn.classList.remove('txt_indent');
            // Open the cart drawer
            openCartDrawer();
        } catch (error) {
            console.error("Error adding item to cart:", error);
        }
    });

// Quick Add Button Handler
document.querySelectorAll('.quick-add__submit').forEach((btn) => {
  btn.addEventListener("click", async (e) => {
    e.preventDefault();
    const form = btn.closest('form');
    const loadingSpinner = form.querySelector('.quick-add__submit .loading__spinner');
    const q_btn = form.querySelector('.quick-add__submit .q_btn');

    if (loadingSpinner) {
      loadingSpinner.classList.remove('hidden');
      q_btn.classList.add('hidden');
    }

    if (form && form.action.endsWith('/cart/add')) {
      try {
        await fetch('/cart/add.js', { method: "POST", body: new FormData(form) });
        await updateCartDrawer();
        await updateCartItemCount();
        openCartDrawer();
      } catch (error) {
        console.error("Error updating cart:", error);
      }

      if (loadingSpinner) {
        loadingSpinner.classList.add('hidden');
        q_btn.classList.remove('hidden');
      }
    }
  });
});

// Cart Icon Handler
document.querySelectorAll('.js-drawer-open-cart').forEach(a => {
  a.addEventListener('click', async (e) => {
    console.log("icon click");
    e.preventDefault();
    await updateCartDrawer();
    openCartDrawer();
    await updateCartItemCount();
  });
});

// Initialize Listeners on Page Load
addCartDrawerListeners();
removeCartDrawerListeners();
addCartUpsellListeners();

$(function() {
  $('body').on('click', '.f-cart-drawer-header-right-close', function () {
    closeCartDrawer();
  });

  $('body').on('change', '.variant_selector_cart', function () {
    let varID = $(this).val();
    let parentELe = $(this).closest('.var_btn');
    $(this).find('option').each(function () {
      if ($(this).attr('value') == varID) {
        let salePrice = $(this).attr('data-price');
        let comparePrice = $(this).attr('data-compare-price');
        if (salePrice) {
          parentELe.siblings('.price-section').find('.actual-price').html(salePrice);
        }
        if (comparePrice) {
          parentELe.siblings('.price-section').find('.discount-price').html(comparePrice);
        }
      }
    });
  });

  $('body').on('change', '.variant_selector_cart_list', function () {
    let varID = $(this).val();
    let $this = $(this);
    $(this).find('option').each(function () {
      if ($(this).attr('value') == varID) {
        let salePrice = $(this).attr('data-price');
        let comparePrice = $(this).attr('data-compare-price');
        if (salePrice) {
          $this.siblings('.price-section').find('.actual-price').html(salePrice);
        }
        if (comparePrice) {
          $this.siblings('.price-section').find('.discount-price').html(comparePrice);
        }
      }
    });
  });


    $('html').on('click', '.xsell-quick-add-to-cart', function () {
      setTimeout(() => {
          updateCartDrawer();
          updateCartItemCount();
      }, 2000);
    });


  
});

